import { getDictionaryCountries } from '../../../../../utils/reducers/getters'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { SupplierModelType } from '@teinor/erp/types/company/supplier'
import { useLocation } from 'react-router-dom'
import ModalCreateCreditor from './ModalCreateCreditor'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import { TwinTableLink } from '../../../../../baseComponents/TwinTable'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderStateName, EditRow, DeleteRow, CustomRenderCountryName } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import RightHeaderTableCreditors from './RightHeaderTableCreditors'
import useUpdateTableInstance from '../../../../../utils/hooks/useUpdateTableInstance'

interface CreditorsProps extends ComponentWithPermissions { }

const Creditors: React.FC<CreditorsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('creditors', 'Acreedores'),
        newText: t('newCreditor', 'Nuevo acreedor'),
    }

    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableCreditor} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateCreditor} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
            <RightHeaderTableCreditors {...{ pageData, openModal, setOpenModal, userPermissions, updateTableInstance }} />} />
    )
}

interface TableCreditorProps extends TableComponentProps { }

const TableCreditor: React.FC<TableCreditorProps> = ({ setTableInstance, userPermissions, setOpened }) => {
    const { t } = useTwinTranslation()
    const countries = getDictionaryCountries()
    const location = useLocation().pathname
    const columns: ColumnTableSchema<SupplierModelType> = [
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Código'),
            sortable: true,
            minWidth: 115,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('code', 'Código') }
            }
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            minWidth: 120,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'fiscal_name',
            dataKey: 'fiscal_name',
            minWidth: 140,
            label: t('fiscalName', 'Nombre Fiscal'),
            sortable: true
        },
        {
            id: 'email',
            dataKey: 'email',
            label: t('email', 'Email'),
            minWidth: 110,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'phone',
            dataKey: 'phone',
            label: t('phone', 'Teléfono'),
        },
        {
            id: 'country',
            dataKey: 'country',
            label: t('country', 'País'),
            customRender: (parameterValue, allRowData) => <CustomRenderCountryName countryId={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: { items: countries, label: t('country', 'País') }
            },
            generalSearchable: false
        },
        {
            id: 'state',
            dataKey: 'state',
            label: t('state', 'Provincia'),
            customRender: (parameterValue, allRowData) => <CustomRenderStateName stateId={parameterValue} allRowData={allRowData} />,
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTableLink createRowDataLink={[location, ['$id', 'main']]} name='creditors' columns={columns} getDataFrom='/api/app/supplier/getAllSuppliers' setTableInstance={setTableInstance} extraWhereParams={{type: 1}} />
    )
}

export default Creditors